import consumer from "./consumer";

consumer.subscriptions.create("ExportationsChannel", {
  connected() {
    // Called when the subscription is ready for use on the server
    console.log("Connected to ExportationsChannel");
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
  },

  received(data) {
    // Called when there's incoming data on the websocket for this channel
    console.log("Received data from ExportationsChannel:", data);
    
    if (data.status === "finished" || data.status === "failed") {
      if (window.location.pathname.includes("/exportations")) {
        window.location.reload();
      } else if (data.message) {
        // You could use a toast library here if available
        alert(data.message);
        if (data.redirect && data.status === "finished") {
          window.location.href = data.redirect;
        }
      }
    }
  }
});
